import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, boolAndReducer, Select, MyDate, MyFormData, mimeTypeMap,
    appTitle
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function JobTags({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const history = useHistory();
    const defaultSelectedDate = {
        start: `${(new Date()).getFullYear()}-${
            ((new Date()).getMonth() + 1) < 10?
            `0${(new Date()).getMonth() + 1}`
            :
            ((new Date()).getMonth() + 1)
        }-01`,
        end: (new MyDate()).s()
    }
    //------------------------------------------------------
    const [currentData, setCurrentData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [query, setQuery] = useState(defaultSelectedDate);
    const [users, setUsers] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showLoading, setShowLoading] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const indexOfLastProject = currentPage * itemsPerPage;
    const indexOfFirstProject = indexOfLastProject - itemsPerPage;
    const filteredData = currentData.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentPageProjects = filteredData.slice(indexOfFirstProject, indexOfLastProject);
    const pageNumbers = Array.from({length: Math.ceil(filteredData.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
  
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            //---------------------------------------------------------------
            setShowLoader(true);
            const resUsers = await myAxios("common/readUserNames.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resUsers) return;
            //---------------------------------------------------------------
            setUsers(resUsers.data.map(user => ({...user, label: user.userName, value: user.email})));
        }
        getData();
        return () => {isMounted = false;}
    }, [setShowLoader])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0">Technician:</label>
                    <span className = "userNameWidth">
                        <Select
                            classNamePrefix = "custom-select"
                            menuPosition = "fixed"
                            className = "text-dark ml-2"
                            options = {users}
                            onChange = {e => setQuery({...query, userEmail: e?.email})}
                        />
                    </span>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "start" className = "mb-0">
                        Start:
                    </label>
                    <input
                        id = "start"
                        type = "date"
                        min = "1900-01-01"
                        max = {(new MyDate()).s() || "2999-12-31"}
                        className = "form-control ml-2"
                        value = {query.start}
                        onChange = {e => setQuery({...query, start: e.currentTarget.value})}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "end" className = "mb-0">
                        End:
                    </label>
                    <input
                        id = "end"
                        type = "date"
                        min = "1900-01-01"
                        max = {(new MyDate()).s() || "2999-12-31"}
                        className = "form-control ml-2"
                        value = {query.end}
                        onChange = {e => setQuery({...query, end: e.currentTarget.value})}
                    />
                </span>
                <span
                    className = "pointer"
                    onClick = {async() => {
                        if(query.userEmail === undefined){
                            window.alert("Please select Technician.");
                            return;
                        }
                        if(query.start === ""){
                            window.alert("Please select start date.");
                            return;
                        }
                        if(query.end === ""){
                            window.alert("Please select end date.");
                            return;
                        }
                        if(query.start > query.end){
                            window.alert("Start date is greater than end date.");
                            return;
                        }
                        const formData = new MyFormData();
                        formData.append("userEmail", query.userEmail);
                        formData.append("start", query.start);
                        formData.append("end", query.end);
                        //---------------------------------------------------------------
                        setShowLoading(true);
                        const res = await myAxios("approvals/readJobtags.php", formData);
                        setShowLoading(false);
                        if(!res) return;
                        //---------------------------------------------------------------
                        setCurrentData(res.data ?? []);
                        setCurrentPage(1);
                    }}
                >
                    Load
                </span>
                <span
                    className = "pointer"
                    onClick = {async() => {
                        console.log("start");
                        if(!window.confirm("Are you sure to download all Job Tags?")) return;
                        if(!filteredData.length){
                            window.alert("No Job Tags Selected. Select ob Tags By Entering `Start Date` and `End Date` Above.");
                            return;
                        }
                        if(filteredData.filter(workLog => workLog.workLogStatus === "Submitted").length){
                            if(!window.confirm("You have unapproved Job Tags. Still proceed?")) return;
                        }
                        window.alert("WARNING: You will still need to verify that there are no remaining Job Tags assigned to this BTL in order to proceed with the billing process.");
                        const formData = new MyFormData();
                        for(const workLog of currentData){
                            formData.append("fileId[]", workLog.jobTag);
                            const duration = workLog.startTime.substring(0, 10) === workLog.endTime.substring(0, 10)?workLog.startTime.substring(0, 10):`from ${workLog.startTime.substring(0, 10)} to ${workLog.endTime.substring(0, 10)}`;
                            formData.append("fileName[]", `${workLog.laborName} ${duration}.pdf`);
                        }
                        //-------------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("common/getFile.php", formData, "blob");
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------------
                        const now = new MyDate();
                        if(currentData.length === 1){
                            saveAs(new Blob([res.data], {type: mimeTypeMap.pdf}), `All Job Tags Downloaded at ${now.s()} ${now.ss()}.pdf`);
                        }else{
                            saveAs(new Blob([res.data], {type: mimeTypeMap.zip}), `All Job Tags Downloaded at ${now.s()} ${now.ss()}.zip`);
                        }
                    }}
                >
                    Download All
                </span>
            </div>
            <div className = "cssContent pb10">
            {showLoading?<div className = "cssLoading">Loading...</div>:
            !currentData.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Project Name</th>
                            <th>Project Category</th>
                            <th>Labor Category</th>
                            <th>Department</th>
                            <th>Submit Time</th>
                            <th>Planned Time</th>  
                            <th>Job Tag</th>
                        </tr>
                        </thead>
                        <tbody> 
                        {currentPageProjects.map((v, key) =>
                            <tr
                                key = {key}
                                className = "pointer"
                                onClick = {e => { 
                                    if(!e.target.id){
                                        history.push(`/Projects/${v.projectHashKey}/WorkInstructions/${v.workInstructionHashKey}/WorkLogs/${v.workLogHashKey}`);
                                    }
                                }}
                            >                 
                                <td>{v.projectName}</td>
                                <td>{v.category}</td>
                                <td>{v.laborCategory}</td>
                                <td>{v.department}</td>
                                <td>
                                    <span className = "font-weight-bold">
                                        {v.workLogSubmitTime.substring(0, 10)}
                                    </span>
                                    {" "}
                                    {v.workLogSubmitTime.substring(11, 16)}
                                </td>
                                <td>
                                    <span className = "font-weight-bold">
                                        {v.startTime.substring(0, 10)}
                                    </span>
                                    {!v.allDay?v.startTime.substring(10, 16):""} 
                                    {v.allDay && v.startTime.substring(0, 10) === v.endTime.substring(0, 10)?"":" ~ "}
                                    <span className = "font-weight-bold">
                                        {
                                            v.startTime.substring(0, 10) === v.endTime.substring(0, 10)?
                                            "":
                                            v.endTime.substring(0, 10)
                                        }
                                    </span>
                                    {!v.allDay?v.endTime.substring(10, 16):""}
                                </td>
                                <td>
                                    <span
                                        id = {v.jobTag}
                                        className = "btn btn-primary"
                                        onClick = {async() => {
                                            const formData = new MyFormData();
                                            formData.append("fileId[]", v.jobTag);
                                            const duration = v.startTime.substring(0, 10) === v.endTime.substring(0, 10)?v.startTime.substring(0, 10):`from ${v.startTime.substring(0, 10)} to ${v.endTime.substring(0, 10)}`;
                                            formData.append("fileName[]", `${v.laborName} ${duration}.pdf`);
                                            //---------------------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("common/getAttachment.php", formData, "blob");
                                            setShowLoader(false);
                                            if(!res) return;
                                            //---------------------------------------------------------------
                                            saveAs(new Blob([res.data]), `${v.laborName} ${duration}.pdf`);
                                        }}
                                    >PDF</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>}
            {!showLoading && currentData.length?
            <Footer
                length = {currentData.length}
                pageNumbers = {pageNumbers}

                currentPage = {currentPage}
                setCurrentPage = {setCurrentPage}
                itemsPerPage = {itemsPerPage}
                setItemsPerPage = {setItemsPerPage}
            />
            :null}
        </div>
    </div>
    )
}